import { useEffect, useState } from "react"
import { BasicPage } from "../theme/Component/BasicPage"
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable"
import { _AdquisitionItem, _single } from "../../core/services/dataBean/EntityCatalog"
import { SelectAdquisitionPlan } from "./select/SelectAdquisitionPlan"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicButton } from "../theme/Component/BasicButton"
import usePaginator from "../theme/Component/usePaginator"
import { toast } from "react-toastify"
import { DropDown } from "../theme/Component/DropDown"
import useModal, { MODAL_md, MODAL_XL } from "../theme/Component/hooks/useModal"
import { ExportXLSL } from "../theme/Component/ExportXLSX"
import { Modal } from "../theme/Component/Modal"
import AutoChart from "../../core/graph/AutoChart"

interface formData {
    Year: number,
    IDPlan: number,
}

export const NeedsRequest = () => {

    const { instance, setBean, bean, lista, setLista, spin } = useDataBean(_AdquisitionItem);
    const paginador = usePaginator();

    const modalcsv = useModal("Exportar Datos", MODAL_md);

    const [listaExport, setListaExport] = useState<any[]>([]);
    const modalGraph = useModal("Grafica", MODAL_XL);

    const [data, setData] = useState<Partial<formData>>({
        Year: _single.getCurrenYear(),
    })

    const head = [
        { title: 'PAA', property: 'IDAdquisitionItem', visible: true, mask: MASK_NUMBER },
        { title: 'Valor', property: 'Amount', visible: true, mask: MASK_MONEY },
        { title: 'Codigo Procedimiento', property: 'AlphaCode', visible: true },
        { title: 'Solicitante', property: 'RequesterEntity', visible: true },
        { title: 'Area Solicitante', property: 'AreaRequestEntity', visible: true },
        { title: 'Consolidador', property: 'ManagerEntity', visible: true },
        { title: 'Area Consolidador', property: 'AreaManagerEntity', visible: true },
        { title: 'Justificación Necesidad', property: 'JustifyItem', visible: true },
        { title: 'Objeto Necesidad', property: 'ItemDescription', visible: true },
        { title: 'Estado', property: 'ProcedureStateName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const getLista = () => {
        let props: any = {
            IDAdquisitionPlan: data.IDPlan
        }

        instance.getRequestAdquisitionItemRender(paginador.page, 15, props).then(
            (resp) => {
                if (resp.List.length > 0) {

                    resp.List.forEach(solicitudes => {

                        const solicitud = solicitudes.DataBeanProperties;

                        solicitud.RequesterEntity = solicitud.RequesterNit ? `${solicitud.RequesterNit} - ${solicitud.RequesterFullName}` : "N/P"
                        solicitud.ManagerEntity = solicitud.ManagerNit ? `${solicitud.ManagerNit} - ${solicitud.ManagerFullName}` : "N/P"
                        solicitud.AreaRequestEntity = solicitud.RequestFunctionalJsonCode ? `${solicitud.RequestFunctionalJsonCode} - ${solicitud.RequestFunctionalName}` : "N/P"
                        solicitud.AreaManagerEntity = solicitud.PlanFunctionalJsonCode ? `${solicitud.PlanFunctionalJsonCode} - ${solicitud.PlanFunctionalName}` : "N/P"

                    });

                    setLista(resp.List);
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                }
                setBean({});
            }
        )
    }

    const getListaExport = () => {
        let props: any = {
            IDAdquisitionPlan: data.IDPlan
        }

        instance.getRequestAdquisitionItemRender(1, 15 * paginador.pages, props).then(
            (resp) => {
                if (resp.List.length > 0) {

                    resp.List.forEach(solicitudes => {

                        const solicitud = solicitudes.DataBeanProperties;

                        solicitud.RequesterEntity = solicitud.RequesterNit ? `${solicitud.RequesterNit} - ${solicitud.RequesterFullName}` : "N/P"
                        solicitud.ManagerEntity = solicitud.ManagerNit ? `${solicitud.ManagerNit} - ${solicitud.ManagerFullName}` : "N/P"
                        solicitud.AreaRequestEntity = solicitud.RequestFunctionalJsonCode ? `${solicitud.RequestFunctionalJsonCode} - ${solicitud.RequestFunctionalName}` : "N/P"
                        solicitud.AreaManagerEntity = solicitud.PlanFunctionalJsonCode ? `${solicitud.PlanFunctionalJsonCode} - ${solicitud.PlanFunctionalName}` : "N/P"

                    });

                    setListaExport(resp.List);
                }
                setBean({});
            }
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDPlan"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (data[field] === null || data[field] === undefined || data[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    useEffect(() => {
        if (paginador.page) {
            validateData()
        }
    }, [paginador.page])

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            modalcsv.open();
        }
        if (e.id === 2) {
            getListaExport();
            modalGraph.open();
        }
    }

    return (
        <BasicPage titulo="Solicitudes de Necesidades">
            <div className="row">
                <div className="col-md-4">
                    <label>Año</label>
                    <input type="number" value={data.Year} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setData({ ...data, Year: value })
                    }} className="form-control" />
                </div>
                <div className="col-md-4">
                    <label className={`${missingFields.includes('IDPlan') ? 'has-error' : ''}`}>Plan de Adquisición</label>
                    <SelectAdquisitionPlan StatePlans={null} label=" " idSelector={data.IDPlan} onChange={(e) => { setData({ ...data, IDPlan: e }) }} _year={data.Year} />
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { validateData() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} records={paginador} />

                    <Modal modal={modalcsv.modal} updateModal={modalcsv.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Plazas Laborales"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['AreaManagerEntity', 'PlanFunctionalName', 'AreaRequestEntity','RequesterEntity']}
                            yOptions={['Amount']} />

                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}